import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { getFaculties, getFacultiesByIdDepartaments } from "../services/school/faculty/getFaculties";
import { PagedRequestType } from "../types/PagedResults";

export const useGetFacultiesQuery = (data: PagedRequestType, options: any = null) => {

  const managerData = useSelector((state: RootState) => state.manager);

  return useQuery(
    ["faculties-pagination", JSON.stringify(data)],
    () => managerData && managerData?.idUser && managerData.isManager && managerData.faculties && managerData.faculties?.length > 0 ? getFaculties(data).then(async (d) => {

      let filteredFaculties = d.items.filter((faculty: any) =>
        managerData.faculties?.some((managerFaculty: any) => managerFaculty === faculty.id)
      );
      if (managerData.departments && managerData.departments.length > 0) {
        const idsDepartaments = managerData.departments;
        const faculties = await getFacultiesByIdDepartaments({ PageNumber: 1, PageSize: 100, IdsDepartaments: idsDepartaments });
        filteredFaculties = Array.from(new Set([...filteredFaculties, ...faculties.items]))
      }
      return { ...d, items: filteredFaculties };
    }) : getFaculties(data),
    options ? { ...options } : {}
  );
};